import React, { memo } from 'react';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Teresa V.',
  age: 68,
  text: 'Se lo compré a mi esposo porque pasaba todo el día viendo noticias. Ahora se sienta en las tardes con su café a resolver los laberintos y sopas de letras. La letra grande es una bendición porque no tiene que forzar la vista.',
  image: 'https://images.unsplash.com/photo-1581579186913-46ac3a6efea3?auto=format&fit=crop&q=80&w=150&h=150'
}, {
  name: 'Antonio M.',
  age: 72,
  text: 'Me encanta que puedo imprimir solo las hojas que quiero hacer en el día. Los juegos de lógica me mantienen pensando y siento que mi memoria está más ágil. Excelente inversión.',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=150&h=150'
}, {
  name: 'Rosa C.',
  age: 65,
  text: 'Los acertijos para conversar con los nietos son mi parte favorita. Cuando vienen a visitarme los domingos, siempre les tengo uno preparado y nos reímos mucho. Un material muy completo.',
  image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&q=80&w=150&h=150'
}, {
  name: 'Miguel A.',
  age: 75,
  text: 'Ya no sabía qué hacer para no aburrirme en casa. Este libro me ha dado una rutina muy bonita. Hago dos o tres juegos por la mañana y me siento muy productivo. Muy recomendado.',
  image: 'https://images.unsplash.com/photo-1506277886164-e25aa3f4ef7f?auto=format&fit=crop&q=80&w=150&h=150'
}, {
  name: 'Carmen P.',
  age: 61,
  text: 'Compré el paquete por el precio de oferta y no puedo creer todo lo que trae. Los juegos son variados y nada aburridos. Lo mejor es que no necesito estar pegada al celular o la tablet.',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=150&h=150'
}];
export function Testimonials() {
  return <section className="py-16 bg-gray-50" data-id="element-20">
      <div className="max-w-5xl mx-auto px-4" data-id="element-21">
        <h2 className="text-3xl md:text-5xl font-black text-center text-gray-900 mb-12 uppercase" data-id="element-22">
          Lo que dicen <span className="text-blue-600" data-id="element-23">nuestros clientes</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-24">
          {TESTIMONIALS.map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 flex flex-col" data-id="element-25">
              <div className="flex text-yellow-400 mb-4" data-id="element-26">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-27" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-28">"{t.text}"</p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-29">
                <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover border-2 border-blue-100" data-id="element-30" />
                <div data-id="element-31">
                  <p className="font-bold text-gray-900" data-id="element-32">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-33">{t.age} años</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}